export const plantationImage = "https://cdn.magicpatterns.com/patterns/generated-images/9763acfe-46d6-4441-a9bb-fa02b63443b2.jpg";
export const mapImage = "https://cdn.magicpatterns.com/patterns/generated-images/9db24c00-f760-4e2a-a132-c600f7122482.jpg";
export const officerImage = "https://cdn.magicpatterns.com/patterns/generated-images/edf52575-4fcf-446b-9b03-45c768d7e0a3.jpg";

export const plantationTypes = [
  ["ব্লক বাগান", "Trees"], ["ANR", "Sprout"], ["Enrichment Planting", "TreePine"], ["শাল কপিস", "Landmark"],
  ["স্ট্রিপ / সড়ক বাগান", "Route"], ["বাঁধ বাগান", "Waves"], ["প্রাতিষ্ঠানিক বাগান", "Building2"], ["ব্যক্তিগত বাগান", "UserRound"]
] as const;

export const plantations = [
  { name: "গাজীপুর ব্লক বাগান ২০২৬", id: "GAZ-BLK-2026-001", place: "গাজীপুর সদর, গাজীপুর", type: "ব্লক বাগান", year: "২০২৬", survival: "৮৭%", date: "১২ সেপ্টেম্বর ২০২৬", status: "সক্রিয়" },
  { name: "কালিয়াকৈর সড়ক বাগান", id: "GAZ-STR-2025-014", place: "কালিয়াকৈর, গাজীপুর", type: "স্ট্রিপ বাগান", year: "২০২৫", survival: "৭৩%", date: "০৮ সেপ্টেম্বর ২০২৬", status: "গ্যাপ ফিলিং প্রয়োজন" },
  { name: "শ্রীপুর বাঁধ বাগান", id: "GAZ-EMB-2024-007", place: "শ্রীপুর, গাজীপুর", type: "বাঁধ বাগান", year: "২০২৪", survival: "৯২%", date: "২৭ আগস্ট ২০২৬", status: "পর্যবেক্ষণ বাকি" },
];

export const quickActions = [
  ["নতুন বাগান", "Plus"], ["পর্যবেক্ষণ", "ClipboardCheck"], ["ম্যাপ", "Map"], ["সিঙ্ক করুন", "RefreshCw"]
] as const;

export const notifications = [
  ["পর্যবেক্ষণের সময় হয়েছে", "কালিয়াকৈর ব্লক বাগানের পরবর্তী পর্যবেক্ষণ ৩ দিনের মধ্যে।", "amber"],
  ["তথ্য অনুমোদিত", "GAZ-BLK-2026-001 রেকর্ডটি অনুমোদিত হয়েছে।", "green"],
  ["সিঙ্ক সম্পন্ন", "১২টি অফলাইন রেকর্ড সফলভাবে সিঙ্ক হয়েছে।", "green"],
  ["গ্যাপ ফিলিং প্রয়োজন", "একটি বাগানের বেঁচে থাকার হার নির্ধারিত সীমার নিচে নেমেছে।", "red"],
] as const;
